<template>
  <main>
    <v-tabs v-model="tab" show-arrows centered>

      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">Profile</v-tab>
      <v-tab href="#tab-2">Change Email</v-tab>
      <v-tab href="#tab-3"  v-if="showPassword === true">Password</v-tab>
      <v-tab href="#tab-4"  v-if="showTicketingLink === true">Link Client Reference</v-tab>
      <v-tab href="#tab-5">Preferences</v-tab>
      <!--<v-tab href="#tab-5" >Membership &amp; Loyalty</v-tab>-->

      <v-tab-item :value="'tab-1'" :key="1">
        <div v-if="configValues.accountProfilePicturesAllowed === true">
        <UserProfileImage  />
        </div>
        <UserProfileFull />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" :value="'tab-2'" :key="2">
        <UserProfileChangeEmail />
      </v-tab-item>

      <v-tab-item v-if="showPassword === true" :value="'tab-3'" :key="3">
        <UserProfilePassword />
      </v-tab-item>

      <v-tab-item v-if="showTicketingLink === true" :value="'tab-4'" :key="4">
        <UserProfileTicketmasterLink />
      </v-tab-item>
      
      <v-tab-item :value="'tab-5'" :key="5">
        <UserProfileContactPrefs />
      </v-tab-item>

      <!--<v-tab-item :value="'tab-5'" :key="5">
        <UserProfileMembership />
        <UserProfileClientRefNo />
      </v-tab-item>-->
    </v-tabs>

    <FooterShout :type="'help'"/>
  </main>
</template>

<script>
  import UserProfileFull from '@/components/UserProfileFull'
  import UserProfilePassword from '@/components/UserProfilePassword'
  import UserProfileChangeEmail from '@/components/UserProfileChangeEmail'
  // import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
  import UserProfileImage from '@/components/UserProfileImage'
  //import UserProfileSeatgeekLink from '@/components/UserProfileSeatgeekLink'
  import UserProfileTicketmasterLink from '@/components/UserProfileTicketmasterLink'
  import UserProfileContactPrefs from '@/components/UserProfileContactPrefs'
  // import UserProfileMembership from '@/components/UserProfileMembership'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      UserProfileFull,
      UserProfileChangeEmail,
      UserProfilePassword,
      // UserProfileClientRefNo,
      UserProfileImage,
      //UserProfileSeatgeekLink,
      UserProfileTicketmasterLink,
      UserProfileContactPrefs,
      // UserProfileMembership,
      FooterShout
    },
    data () {
      return {
        showPassword: false,
        showMembership: false,
        showTicketingLink: false,
        tab: "tab-1"
      }
    },
    mounted () {
        console.log('User Profile component loaded')
        
        if(this.$getAuthenticatedUser() == null){
          console.log('User is not logged in')
          this.$router.push("/");
        } else {
          
          if(localStorage.loginFlow == "TicketMasterNoClientRef"){
            this.tab =  "tab-4"
          }
          // check to see if the user was created with traditional registration (and not Facebook or Google)
          this.$getCurrentUserAttributes().subscribe((userData) => {
            if(userData.email_verified){
              console.log('user allowed to change password')
              this.showPassword = true //if they did register with their email, then let them change password
            } 
            // Allow ticketing link tab to be seen if user is from approved organisation
            if(
              this.configValues.seatGeekAccountLinkingEnabled === true 
              && 
              (
                userData.email.includes('@urbanzoo.io') ||
                userData.email.includes('@'+this.configValues.clubRootDomain) ||
                userData.email.includes('@seatgeek.com')
              )
            ){ 
              this.showTicketingLink = true
            }
          })
        }
        console.log(this.$root.$data.referrer)

    }
  }
</script>
<style lang="scss" scoped>

  .theme--light.v-tabs__bar .v-tabs__div {
    color: $primary-club-light;
  }
</style>
